import React, { useState } from 'react';
import './Styles.css';
import { InputField, InputFieldAddon, InputFieldWrapper, InputSize } from '@ids/react-input-field';
import { IconButton, IconButtonSize, IconButtonType, IconButtonVariant } from '@ids/react-icon-button';
import { Ui32ArrowSmDown, Ui32ArrowSmUp } from '@ids/react-icons';
import { canShowTeamTypeSelector, getParentTeamTypeOptions, useParentTeamSerach } from './Functions';
import { TeamType } from '../../../../../../Enums/TeamType';
import { useLegalUnitName } from '../../../../../../Helpers/CustomHooks';
import { canParentTeamBeSet } from '../../../../Functions';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';
import Select from '../../../../../../Elements/ids/InputElements/Select';
import LoaderComponent from '../../../../../../Elements/ids/Loader';

const ParentTeamCodePrefix = ({ team, editedTeamData, setEditedTeamData }) => {
  const [parentTeamCodePrefixState, setParentTeamCodePrefixState] = useState({
    query: editedTeamData.parentTeamCodePrefix || null,
    isLoading: false,
    isOpen: false,
  });
  const legalUnitName = useLegalUnitName(team);

  const teamList = useParentTeamSerach(
    parentTeamCodePrefixState.query,
    isLoading => {
      setParentTeamCodePrefixState({ ...parentTeamCodePrefixState, isLoading });
    },
    isOpen => {
      setParentTeamCodePrefixState({ ...parentTeamCodePrefixState, isOpen });
    },
    editedTeamData.parentTeamCodePrefix
  );

  return (
    <>
      {canParentTeamBeSet(legalUnitName) && (
        <div className="teamPage-teamInfo-parentTeam-container">
          <div>
            <label>{formatMessage(Messages.common_parentTeam)}</label>
            <InputFieldWrapper
              inputSize={InputSize.SMALL}
              onClick={() => {
                if (!parentTeamCodePrefixState.isOpen) {
                  setParentTeamCodePrefixState({ ...parentTeamCodePrefixState, isOpen: true });
                }
              }}>
              <InputField
                inputSize={InputSize.SMALL}
                onChange={e => {
                  setParentTeamCodePrefixState({ ...parentTeamCodePrefixState, query: e.target.value });
                  if (e.target.value.trim().length === 0) {
                    setEditedTeamData({ ...editedTeamData, parentTeamCodePrefix: null });
                  }
                }}
                value={parentTeamCodePrefixState.query ?? editedTeamData.parentTeamCodePrefix}
                autoComplete="off"
              />
              <InputFieldAddon>
                <IconButton
                  type={IconButtonType.PLAIN}
                  variant={IconButtonVariant.QUIET}
                  size={IconButtonSize.X_SMALL}
                  onClick={() => {
                    if (parentTeamCodePrefixState.isOpen) {
                      setParentTeamCodePrefixState({ ...parentTeamCodePrefixState, isOpen: false });
                    }
                  }}>
                  {parentTeamCodePrefixState.isOpen ? <Ui32ArrowSmUp /> : <Ui32ArrowSmDown />}
                </IconButton>
              </InputFieldAddon>
            </InputFieldWrapper>
            {parentTeamCodePrefixState.isLoading ? (
              <LoaderComponent />
            ) : (
              <>
                {parentTeamCodePrefixState.isOpen && (
                  <ul className="teamPage-teamInfo-parentTeam-searchResults">
                    {teamList.map(team => (
                      <li
                        key={team.codePrefix}
                        className="teamPage-teamInfo-parentTeam-searchResults-row clickable"
                        onClick={() => {
                          setEditedTeamData({ ...editedTeamData, parentTeamCodePrefix: team.codePrefix });
                          setParentTeamCodePrefixState({
                            ...parentTeamCodePrefixState,
                            isOpen: false,
                            query: null,
                          });
                        }}>
                        {team.codePrefix}
                      </li>
                    ))}
                  </ul>
                )}
              </>
            )}
          </div>

          {canShowTeamTypeSelector(editedTeamData) && (
            <div className="teamPage-teamInfo-parentTeam-type">
              <Select
                label={formatMessage(Messages.teamInfo_teamType)}
                defaultValue={editedTeamData.teamType ?? TeamType.Regular}
                onChange={e => {
                  setEditedTeamData({ ...editedTeamData, teamType: e.target.value });
                }}
                options={getParentTeamTypeOptions()}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ParentTeamCodePrefix;
